import Enum from "../../../../enums/Enum";

const IntakeFormRadTextEnum = new Enum({
    // Form Headers
    Intake_Form_Rad_Title: {English: "NEW PATIENT HEALTH HISTORY FORM", Arabic: "نموذج التاريخ الصحي للمرضى الجدد للأشعة"},
    Intake_Form_Rad_Header: {English: "Radiology Intake Form", Arabic: "نموذج قسم الأشعة للمرضى الجدد"},
    New_Patient_Form_Rad_Header: {English: "New Patient Form - Radiology", Arabic: "نموذج المرضى الجدد - الأشعة"},
    New_Patient_Form_Rad_Title: {English: "NEW PATIENT HEALTH HISTORY FORM - RADIOLOGY", Arabic: "نموذج التاريخ الصحي للمرضى الجدد - الأشعة"},

    // Common Fields
    MRN: {English: "MRN", Arabic: "رقم الملف الطبي"},
    Date: {English: "Date", Arabic: "التاريخ"},
    Yes: {English: "Yes", Arabic: "نعم"},
    No: {English: "No", Arabic: "لا"},
    NA: {English: "N/A", Arabic: "غير متوفر"},

    // Personal Information Section
    Personal_Information: {English: "PERSONAL INFORMATION", Arabic: "المعلومات الشخصية"},
    Name: {English: "Name", Arabic: "الاسم"},
    First_Name: {English: "First Name", Arabic: "الاسم الأول"},
    Middle_Name: {English: "Middle Name", Arabic: "الاسم الأوسط"},
    Last_Name: {English: "Last Name", Arabic: "اسم العائلة"},
    Date_of_Birth: {English: "Date of Birth (D/M/Y)", Arabic: "تاريخ الميلاد"},
    Age: {English: "Age", Arabic: "العمر"},
    Gender: {English: "Gender", Arabic: "الجنس"},
    Male: {English: "Male", Arabic: "ذكر"},
    Female: {English: "Female", Arabic: "أنثى"},
    ID_No: {English: "ID No.", Arabic: "رقم الهوية"},
    Nationality: {English: "Nationality", Arabic: "الجنسية"},
    Marital_Status: {English: "Marital Status", Arabic: "الحالة الاجتماعية"},
    Religion: {English: "Religion", Arabic: "الديانة"},
    Language: {English: "Language", Arabic: "اللغة"},

    // Contact Information Section
    Contact_Information: {English: "CONTACT INFORMATION", Arabic: "معلومات التواصل"},
    Phone_Number: {English: "Phone Number", Arabic: "رقم الهاتف"},
    Do_You_Use_This_Number_For_Whatsapp: {English: "Do you use this number for Whatsapp?", Arabic: "هل تستخدم نفس الرقم لتطبيق الواتس آب؟"},
    Whatsapp_Number: {English: "WhatsApp Number", Arabic: "رقم الواتساب"},
    Email: {English: "Email", Arabic: "البريد الإلكتروني"},
    Address: {English: "Address", Arabic: "العنوان"},
    Country: {English: "Country", Arabic: "الدولة"},
    City: {English: "City", Arabic: "المدينة"},
    Postal_Code: {English: "Postal Code", Arabic: "الرمز البريدي"},
    Allergies_Or_Sensitivities: {English: "Do you have any Allergies or Sensitivities?", Arabic: "هل تعاني من أي نوع حساسية أو فرط التحسس؟"},
    
    // Allergies Details Section
    Allergy_Type: {English: "Allergy Type", Arabic: "نوع الحساسية"},
    Allergy_Medication: {English: "Medication Allergy", Arabic: "حساسية الأدوية"},
    Medication_Allergy_Name: {English: "Medication Allergy Name", Arabic: "اسم حساسية الدواء"},
    Medication_Name: {English: "Medication Name", Arabic: "اسم الدواء"},
    Allergen: {English: "Allergen", Arabic: "مسبب الحساسية"},
    Other_Allergen: {English: "Specify Allergen", Arabic: "حدد مسبب الحساسية"},
    Severity: {English: "Severity", Arabic: "الشدة"},
    Detail: {English: "Detail", Arabic: "التفاصيل"},
    Details: {English: "Details / Reaction", Arabic: "التفاصيل / التفاعل"},
    Reaction_Type: {English: "Reaction Type", Arabic: "نوع التفاعل"},
    Other_Reaction: {English: "Other Reaction", Arabic: "تفاعل آخر"},
    Select_Type: {English: "Select Type", Arabic: "اختر النوع"},
    Food: {English: "Food", Arabic: "غذاء"},
    Pet: {English: "Pet", Arabic: "حيوانات أليفة"},
    Seasonal: {English: "Seasonal", Arabic: "موسمي"},
    Environmental: {English: "Environmental", Arabic: "بيئي"},

    // Referral Information Section
    Referral_Information: {English: "REFERRAL INFORMATION", Arabic: "معلومات الإحالة"},
    How_Did_You_Hear_About_Clinic: {English: "How did you hear about the clinic?", Arabic: "كيف سمعت عن العيادة؟"},
    Referring_Physician: {English: "Who is your referring physician?", Arabic: "من هو الطبيب المحيل؟"},
    Reason_For_Imaging: {English: "What is the reason for your imaging exam?", Arabic: "ما سبب إجراء الفحص بالأشعة؟"},

    // Emergency Contact Section
    Emergency_Contact: {English: "EMERGENCY CONTACT", Arabic: "جهة الاتصال في حالات الطوارئ"},
    Emergency_Contact_Name: {English: "Name", Arabic: "الاسم"},
    Emergency_Contact_Relationship: {English: "Relationship", Arabic: "العلاقة"},
    Emergency_Contact_Phone: {English: "Phone Number", Arabic: "رقم الهاتف"},

    // Health History Section
    Health_History: {English: "HEALTH HISTORY", Arabic: "التاريخ الطبي"},
    You_Or_Family_Suffer: {English: "Do you or any member of your family suffer from any of the following? (Check all that apply)", Arabic: "هل تعاني أو أي من أفراد عائلتك من أحد الأمراض التالية؟ (ضع علامة على كل ما ينطبق)"},
    Self: {English: "Self", Arabic: "بالنسبة لك"},
    Family: {English: "Family", Arabic: "بالنسبة للعائلة"},
    Mark_All: {English: "Mark All", Arabic: "وضع علامة على الكل"},

    // Medical Conditions
    Asthma: {English: "Asthma", Arabic: "الربو"},
    Tuberculosis: {English: "Tuberculosis", Arabic: "السل"},
    Pneumonia: {English: "Pneumonia", Arabic: "التهاب الرئة"},
    COVID_19: {English: "COVID-19 (or other lung diseases)", Arabic: "كوفيد-19 (أو أمراض الرئة الأخرى)"},
    Cancer: {English: "Cancer", Arabic: "السرطان"},
    Osteoarthritis: {English: "Osteoarthritis", Arabic: "التهاب العظام والمفاصل"},
    Osteoporosis: {English: "Osteoporosis", Arabic: "هشاشة العظام"},
    Rheumatoid_Arthritis: {English: "Rheumatoid Arthritis", Arabic: "التهاب المفاصل الروماتويدي"},
    Thyroid_Disease: {English: "Thyroid disease", Arabic: "مرض الغدة الدرقية"},
    Abdominal_Diseases: {English: "Abdominal diseases", Arabic: "أمراض البطن"},
    Breast_Diseases: {English: "Breast Diseases (mass, malignancy)", Arabic: "أمراض الثدي (كتلة، خبيثة)"},
    Diabetes: {English: "Diabetes", Arabic: "السكري"},
    Kidney_Disease: {English: "Kidney disease", Arabic: "مرض الكلى"},
    Heart_Disease: {English: "Heart disease", Arabic: "أمراض القلب"},
    Other: {English: "Other", Arabic: "أخرى"},
    If_Family_Who: {English: "If Family, who?", Arabic: "إذا كان أحد أفراد العائلة، الرجاء تحديد من"},

    // Medication and Surgery
    On_Any_Medication_Supplements: {English: "Are you on any medication/supplements?", Arabic: "هل تتناول أي أدوية/مكملات؟"},
    No_Medication: {English: "No", Arabic: "لا"},
    Current_Medication: {English: "Current", Arabic: "حالياً"},
    Previous_Medication: {English: "Previous", Arabic: "سابقاً"},
    Long_term_Medication: {English: "Long-term", Arabic: "طويل الأمد"},
    If_Yes_Name_Medication: {English: "If yes, name of medication/supplement", Arabic: "إذا كانت الإجابة نعم، اسم الدواء/المكم"},
    Ever_Had_Surgery: {English: "Have you ever had a surgery?", Arabic: "هل سبق وأجريت أي جراحة؟"},
    If_Yes_When_What_Surgery: {English: "If yes, when and what surgery?", Arabic: "إذا كانت الإجابة نعم، متى وما هي الجراحة؟"},
    Currently_Receiving_Healthcare: {English: "Are you currently receiving health care for any other reason?", Arabic: "هل تتلقى حاليًا رعاية صحية لأي سبب آخر؟"},
    Had_Previous_Imaging: {English: "Have you had any X-rays taken or other special imaging such as MRI or CT Scan?", Arabic: "هل أجريت أي أشعة سينية أو تصوير خاص آخر مثل التصوير بالرنين المغناطيسي أو الأشعة المقطعية؟"},
    If_Yes_Please_Specify: {English: "If yes, please specify", Arabic: "إذا كانت الإجابة نعم، الرجاء التحدي"},

    // Lifestyle
    Exercise_Type: {English: "Exercise Type:", Arabic: "نوع التمرين:"},
    Exercise_Recreational: {English: "Recreational", Arabic: "ترفيهي"},
    Exercise_Classes: {English: "Classes", Arabic: "دروس"},
    Exercise_Personal_Trainer: {English: "Personal Trainer", Arabic: "مدرب شخصي"},
    Exercise_Performance_Sports: {English: "Performance Sports", Arabic: "رياضة أداء"},
    Do_You_Smoke: {English: "Do you smoke?", Arabic: "هل تدخن؟"},
    Have_You_Ever_Smoked: {English: "Have you ever smoked?", Arabic: "هل سبق لك التدخين؟"},
    Do_You_Consume_Alcohol: {English: "Do you consume alcohol?", Arabic: "هل تتناول الكحول؟"},

    // Pregnancy Related
    Currently_Pregnant: {English: "Are you currently Pregnant?", Arabic: "هل أنت حامل حاليًا؟"},
    Last_Menstrual_Period: {English: "What was the first day of your last menstrual period (LMP)?", Arabic: "تاريخ أول يوم من آخر دورة شهرية؟"},
    Date_Format_DD_MM_YYYY: {English: "(dd/mm/yyyy)", Arabic: "(يوم/شهر/سنة)"},

    // Radiology-Specific Questions
    Had_Contrast_Dye_Last_6_Days: {English: "Have you had any injection of radiographic contrast or dye (IV or oral) in the last 6 days?", Arabic: "هل تلقيت أي حقنة من صبغة التباين الإشعاعي (عن طريق الوريد أو الفم) في الأيام الستة الماضية؟"},
    Calcium_Vitamin_D_Today: {English: "Have you taken any calcium or Vitamin D supplements today?", Arabic: "هل تناولت أي مكملات الكالسيوم أو فيتامين د اليوم؟"},
    Calcium_Vitamin_D_Last_24_Hours: {English: "Have you taken any calcium or Vitamin D supplements within the past 24 hours?", Arabic: "هل تناولت أي مكملات الكالسيوم أو فيتامين د خلال الـ 24 ساعة الماضية؟"},
    Nuclear_Medicine_Scan_Barium_Last_6_Days: {English: "Have you undergone any nuclear medicine scan or barium exam in the last 6 days?", Arabic: "هل خضعت لأي فحص طب نووي أو فحص باريوم في الأيام الستة الماضية؟"},
    Dexa_Scan_Last_12_Months: {English: "Have you had a DEXA body composition scan in the past 12 months?", Arabic: "هل أجريت فحص تكوين الجسم DEXA في الأشهر الـ 12 الماضية؟"},
    Fasting_For_Ultrasound_Xray: {English: "If you are scheduled for an abdominal ultrasound or X-ray, have you followed the required 6–8 hours fasting before your appointment?", Arabic: "إذا كان لديك موعد للموجات فوق الصوتية للبطن أو الأشعة السينية، هل اتبعت الصيام المطلوب لمدة 6-8 ساعات قبل موعدك؟"},
    Not_Applicable: {English: "Not applicable", Arabic: "غير قابل للتطبيق"},

    // Wizard Navigation
    Wizard_Previous: {English: "Previous", Arabic: "السابق"},
    Wizard_Next: {English: "Next", Arabic: "التالي"},
    Wizard_Save: {English: "Save", Arabic: "حفظ"},

    // Validation Messages
    Required_Field: {English: "This field is required", Arabic: "هذا الحقل مطلوب"},
    Invalid_Email: {English: "Please enter a valid email address", Arabic: "الرجاء إدخال عنوان بريد إلكتروني صحيح"},
    Invalid_Phone: {English: "Please enter a valid phone number", Arabic: "الرجاء إدخال رقم هاتف صحيح"},
    Invalid_Date: {English: "Please enter a valid date", Arabic: "الرجاء إدخال تاريخ صحيح"}
});

export default IntakeFormRadTextEnum;